import React, { useCallback, useState } from 'react'
import ConnectionFailed from './ConnectionFailed'
import ConnectionSuccessfull from './ConnectionSuccessfull'
import ConnectionLoading from './ConnectionLoading'
import ConnectVehiclesList from './ConnectVehiclesList'
import { connectVehicles } from '../../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { isEmpty } from 'lodash'
import { useQuery } from 'src/Hooks/useQuery'
import { ConnectVehicle } from '../../models'
import { useRouting } from '../../hooks'
import { useParams } from 'react-router-dom'

const VENDOR_ACCOUNT_URL_PARAMETER = 'vendorAccount'

/*
 * Shows a list of vehicles which can be connected or already are connected to EHA.
 */
const ConnectVehicles = (): JSX.Element => {
  const [selectedVehiclesIds, setSelectedVehiclesIds] = useState<string[]>([])
  const [isConnecting, setIsConnecting] = useState<boolean>(false)
  const [connectionFailed, setConnectionFailed] = useState<boolean | undefined>(undefined)
  const [connectedVehicles, setConnectedVehicles] = useState<ConnectVehicle[]>()
  const { navigateToConnectVehiclesPage } = useRouting()
  const { installationId } = useParams<{ installationId: string }>()

  const urlParameters = useQuery()
  const vendorAccount = urlParameters.get(VENDOR_ACCOUNT_URL_PARAMETER) ?? undefined

  const authFetch = useAuthFetchWithResponse()

  const handleConnectVehicles = useCallback(async () => {
    if (vendorAccount && !isEmpty(selectedVehiclesIds)) {
      setIsConnecting(true)
      setTimeout(async () => {
        try {
          const response = await connectVehicles(vendorAccount, selectedVehiclesIds, Number(installationId), authFetch)
          if (response.hasErrors) setConnectionFailed(true)
          if (response.value) setConnectedVehicles(response.value)
        } catch (err) {
          console.error(err)
        } finally {
          setIsConnecting(false)
        }
      }, 1000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehiclesIds, vendorAccount])

  const retryToConnect = async (): Promise<void> => {
    setConnectionFailed(undefined)
    await handleConnectVehicles()
  }

  const handleBackButtonClick = (): void => {
    setConnectionFailed(undefined)
    navigateToConnectVehiclesPage()
  }

  if (isConnecting) {
    return <ConnectionLoading />
  }

  if (connectionFailed) {
    return <ConnectionFailed retryToConnect={retryToConnect} handleBackButtonClick={handleBackButtonClick} />
  }

  if (!connectedVehicles) {
    return (
      <ConnectVehiclesList
        installationId={installationId}
        selectedVehiclesIds={selectedVehiclesIds}
        setSelectedVehiclesIds={setSelectedVehiclesIds}
        vendorAccount={vendorAccount}
        handleConnectVehicles={handleConnectVehicles}
      />
    )
  }

  return <ConnectionSuccessfull installationId={installationId} />
}

export default ConnectVehicles
